import { api } from ".";

const basePath = "/dashboard";

type FilterParams = {
  department?: string | null;
  role?: string | null;
};

export const getLiveActivity = async (
  filters: FilterParams,
  otherFilters: any
) => {
  try {
    const { data } = await api.get(`${basePath}/liveActivity`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
        name: otherFilters.name || undefined,
        terminal: otherFilters.terminal || undefined,
        action: otherFilters.action || undefined,
        status: otherFilters.status || undefined,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getLiveTotalEmployee = async (filters: FilterParams) => {
  try {
    const { data } = await api.get(`${basePath}/liveTotalEmployee`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getLiveBirthday = async (filters: FilterParams) => {
  try {
    const { data } = await api.get(`${basePath}/liveBirthday`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getLiveAverageWork = async (filters: FilterParams) => {
  try {
    const { data } = await api.get(`${basePath}/liveAverageWork`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getLiveOvertimeCount = async (filters: FilterParams) => {
  try {
    const { data } = await api.get(`${basePath}/liveOvertimeCount`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getLiveTotalTodayEmployee = async (filters: FilterParams) => {
  try {
    const { data } = await api.get(`${basePath}/liveTotalTodayEmployee`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getLiveNotArrived = async (filters: FilterParams, sort : any) => {
  try {
    const { data } = await api.get(`${basePath}/liveNotArrived`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
        sort: sort,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getLiveWeeklyAnalysis = async (filters: FilterParams) => {
  try {
    const { data } = await api.get(`${basePath}/liveWeeklyAnalysis`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getLiveTodayShifts = async (filters: FilterParams) => {
  try {
    const { data } = await api.get(`${basePath}/liveTodayShifts`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getLiveTopMenu = async () => {
  try {
    const { data } = await api.get(`${basePath}/liveTopMenu`, {});
    return data;
  } catch (error) {
    return error;
  }
};
